import Report from "report";
export function createAsyncGuard(router) {
  router.beforeEach(async (to, from, next) => {
    const storageData = JSON.parse(localStorage.getItem("userInfo"));
    if (process.env.NODE_ENV === "production" && storageData && to.meta.title) {
      const { department, parentOrgNames, username } = storageData;
      parentOrgNames.push(department);
      if (Report.dbtId === "unknown") {
        const params = {
          username, //登录账号
          dbtId: "y6613ya1onvvpymp97253192", //
          chnl: parentOrgNames.join("/"), //部门详情
        };
        Report.init(params);
      }
      Report.reportEvent({
        eventName: "ui_open", // 名称固定为 ui_open
        properties: {
          ui_name: to.meta.title, //菜单名称
        },
      });
    }

    next();
  });
}
